/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@popperjs/core')) :
  typeof define === 'function' && define.amd ? define(['@popperjs/core'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.bootstrap = factory(global.Popper));
})(this, (function (Popper) { 'use strict';

  // ... (keep all the existing Bootstrap code unchanged)

}));

// Custom JavaScript starts here
let menuOpen;
let menuOverflowTimeout;
let isCountdownPlaying = true;
let isVideoPlaying = false;
let player;
let bgVideo; // Add this line to store the background video element
let isBackgroundVideoPlaying = true;

function closeOffCanvas() {
  if (menuOpen) {
    menuOpen.classList.remove('show');
    document.body.classList.remove('offcanvas-active');
    menuOpen.classList.remove('menu-overflow');
    if (menuOverflowTimeout) {
      clearTimeout(menuOverflowTimeout);
    }
    menuOpen = null;
  }
}

function showOffCanvas(offcanvasId) {
  if (menuOverflowTimeout) {
    clearTimeout(menuOverflowTimeout);
  }

  const offcanvasElement = document.getElementById(offcanvasId);
  if (offcanvasElement) {
    offcanvasElement.classList.add('show');
    document.body.classList.add('offcanvas-active');
    menuOpen = document.querySelector('.mobile-offcanvas.show');
    if (menuOpen) {
      setTimeout(() => {
        const button = menuOpen.querySelector('button');
        if (button) {
          button.focus();
        }
      }, 200);

      menuOverflowTimeout = setTimeout(() => {
        if (menuOpen) {
          menuOpen.classList.add('menu-overflow');
        }
      }, 300);
    }
  }
}

function setupMenuLinks() {
  const menuLinks = document.querySelectorAll('.mobile-offcanvas a.nav-link[href^="#"]');
  const linkToSectionMap = {};

  menuLinks.forEach((link) => {
    const sectionId = link.getAttribute("href").substring(1);
    linkToSectionMap[sectionId] = link;

    link.addEventListener("click", (event) => {
      event.preventDefault();
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        menuLinks.forEach((menuLink) => menuLink.classList.remove("active"));
        link.classList.add("active");
        closeOffCanvas();
      }
    });
  });

  window.addEventListener("scroll", () => {
    const scrollPosition = window.scrollY;
    let closestSectionId = null;
    let closestDistance = Number.MAX_VALUE;

    for (const sectionId in linkToSectionMap) {
      const section = document.getElementById(sectionId);
      if (section) {
        const distance = Math.abs(section.offsetTop - scrollPosition);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSectionId = sectionId;
        }
      }
    }

    menuLinks.forEach((link) => link.classList.remove("active"));
    if (scrollPosition + window.innerHeight >= document.body.scrollHeight) {
      menuLinks[menuLinks.length - 1].classList.add("active");
    } else if (closestSectionId) {
      linkToSectionMap[closestSectionId].classList.add("active");
    }
  });
}

function setupCountDown(timerBlock, timer) {
  const countDownDate = new Date('November 22, 2024 08:00:00').getTime();
  let interval;

  // This function calculates the time remaining until the target date
  const updateTimer = () => {
    const now = new Date().getTime();
    const distance = countDownDate - now; // Time difference in milliseconds
    if (distance < 0) return; // Stop if we've passed the target date

    // Calculate days, hours, minutes and seconds remaining
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    timerBlock.style.display = 'flex';
    timer.innerHTML = `<div>${days}<span>days</span></div><div>${hours}<span>hours</span></div><div>${minutes}<span>minutes</span></div><div>${seconds}<span>seconds</span></div>`;
  };

  interval = setInterval(updateTimer, 1000);
  setTimeout(() => {
    timer.style.visibility = 'visible';
    timer.style.opacity = '1';
  }, 1000);

  return {
    start: () => {
      if (!interval) {
        interval = setInterval(updateTimer, 1000);
      }
      isCountdownPlaying = true;
    },
    pause: () => {
      clearInterval(interval);
      interval = null;
      isCountdownPlaying = false;
    },
    isPlaying: () => isCountdownPlaying
  };
}

function toggleCountdown(animationBtn, countDown) {
  const icon = animationBtn.querySelector('i');
  const label = animationBtn.querySelector('span');
  
  if (countDown.isPlaying()) {
    countDown.pause();
    icon.className = 'bx bx-play';
    label.innerText = 'Start animations';
    animationBtn.setAttribute('aria-label', 'Start animations');
    if (bgVideo) bgVideo.pause(); // Pause the background video
  } else {
    countDown.start();
    icon.className = 'bx bx-pause';
    label.innerText = 'Stop animations';
    animationBtn.setAttribute('aria-label', 'Stop animations');
    if (bgVideo) bgVideo.play(); // Play the background video
  }
}

function toggleVideo(videoBtn) {
  const icon = videoBtn.querySelector('i');
  const label = videoBtn.querySelector('span');
  
  if (player) {
    if (isVideoPlaying) {
      player.pauseVideo();
      icon.className = 'bx bx-play';
      label.innerText = 'Play video';
      videoBtn.setAttribute('aria-label', 'Play video');
    } else {
      player.playVideo();
      icon.className = 'bx bx-pause';
      label.innerText = 'Pause video';
      videoBtn.setAttribute('aria-label', 'Pause video');
    }
    isVideoPlaying = !isVideoPlaying;
  }
}

function trapFocus(element) {
  const focusableEls = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];

  element.addEventListener('keydown', function (e) {
    const isTabPressed = (e.key === 'Tab' || e.keyCode === 9);
    if (!isTabPressed) return;

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });
}

function setupYouTubePlayer() {
  const tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubeIframeAPIReady = function() {
    player = new YT.Player('video', {
      videoId: 'TxzBWcboPL4',
      playerVars: {
        'controls': 0,
        'iv_load_policy': 3,
        'modestbranding': 1,
        'rel': 0,
        'showinfo': 0
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
    });
  };

  function onPlayerReady(event) {
    const playerPoster = document.querySelector('.player__poster');
    const playerPosterThumb = playerPoster.querySelector('.player__poster-thumb');
    const thumb = '/wp-content/themes/wud-new-wp-theme/static/dist/assets/img/video.jpg';

    playerPosterThumb.src = thumb;
    playerPosterThumb.onload = () => player.getIframe().classList.remove('player--state-loading');

    playerPoster.onclick = () => {
      player.playVideo();
      playerPoster.classList.add('player__poster--hidden');
      isVideoPlaying = true;
      updateVideoButton();
    };
  }

  function onPlayerStateChange(event) {
    let playerProgress;
    switch (event.data) {
      case YT.PlayerState.PLAYING:
        playerProgress = setInterval(() => playerProgressInterval(), 100);
        isVideoPlaying = true;
        break;
      case YT.PlayerState.PAUSED:
        clearInterval(playerProgress);
        isVideoPlaying = false;
        break;
    }
    updateVideoButton();
  }

  function playerProgressInterval() {
    const playerProgressIndicator = document.querySelector('.player__progress-indicator');
    const videoDuration = player.getDuration();
    playerProgressIndicator.style.left = (100 / videoDuration * player.getCurrentTime()) + '%';
  }
}

function updateVideoButton() {
  const videoBtn = document.querySelector('.btn-video');
  if (videoBtn) {
    const icon = videoBtn.querySelector('i');
    const label = videoBtn.querySelector('span');
    
    if (isVideoPlaying) {
      icon.className = 'bx bx-pause';
      label.innerText = 'Pause video';
      videoBtn.setAttribute('aria-label', 'Pause video');
    } else {
      icon.className = 'bx bx-play';
      label.innerText = 'Play video';
      videoBtn.setAttribute('aria-label', 'Play video');
    }
  }
}

function toggleBackgroundVideo(animationBtn) {
  const icon = animationBtn.querySelector('i');
  const label = animationBtn.querySelector('span');
  
  if (bgVideo) {
    if (isBackgroundVideoPlaying) {
      bgVideo.pause();
      icon.className = 'bx bx-play';
      label.innerText = 'Start animations';
      animationBtn.setAttribute('aria-label', 'Start animations');
    } else {
      bgVideo.play();
      icon.className = 'bx bx-pause';
      label.innerText = 'Stop animations';
      animationBtn.setAttribute('aria-label', 'Stop animations');
    }
    isBackgroundVideoPlaying = !isBackgroundVideoPlaying;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setupMenuLinks();

  document.querySelectorAll('[data-trigger]').forEach(function (element) {
    const offcanvasId = element.getAttribute('data-trigger');
    element.addEventListener('click', (e) => {
      e.preventDefault();
      showOffCanvas(offcanvasId);
    });
  });

  document.querySelectorAll('.close').forEach(function (button) {
    button.addEventListener('click', closeOffCanvas);
  });

  document.querySelectorAll('.nav-link').forEach(function (link) {
    link.addEventListener('click', closeOffCanvas);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth <= 992) {
      closeOffCanvas();
    }
  });

  if (window.innerWidth <= 992) {
    closeOffCanvas();
  }

  // Background video button setup
  const animationBtn = document.querySelector('.btn-animation');
  if (animationBtn) {
    animationBtn.addEventListener('click', () => {
      toggleBackgroundVideo(animationBtn);
      if (countDown && animationBtn.classList.contains('timer')) {
        toggleCountdown(animationBtn, countDown);
      }
    });
  }

  // Countdown setup
  const timerBlock = document.querySelector('.timer-block');
  const timer = document.querySelector('.timer');
  let countDown;

  if (timer && timerBlock) {
    countDown = setupCountDown(timerBlock, timer);
  }

  // Countdown button setup
  if (animationBtn) {
    animationBtn.addEventListener('click', () => toggleCountdown(animationBtn, countDown));
  }

  // Video button setup
  const videoBtn = document.querySelector('.btn-video');
  if (videoBtn) {
    videoBtn.addEventListener('click', () => toggleVideo(videoBtn));
  }

  document.addEventListener('keyup', (event) => {
    menuOpen = document.querySelector('.mobile-offcanvas.show');
    if (menuOpen) {
      if (event.code === 'Escape') {
        closeOffCanvas();
      } else {
        trapFocus(menuOpen);
      }
    }
  });

  // YouTube player setup
  setupYouTubePlayer();

  // Background video setup
  bgVideo = document.getElementById('bg-video');
});

//Speaker video
document.addEventListener('DOMContentLoaded', () => {
  const thumbnail = document.getElementById('custom-thumbnail');
  const video = document.getElementById('youtube-video');

  // Set the path of the custom thumbnail image
  const customThumbnailPath = '/wp-content/themes/wud-new-wp-theme/static/dist/assets/img/speaker-intro-cover.jpg';
  thumbnail.src = customThumbnailPath;

  // Add event listener to the thumbnail
  thumbnail.addEventListener('click', () => {
    // Hide the thumbnail
    thumbnail.classList.add('hidden');

    // Unmute the video by reloading the iframe without the "mute=1" parameter
    const videoSrc = video.src.replace('mute=1', 'mute=0');

    // Reload the iframe with sound enabled and autoplay
    video.src = videoSrc + '&autoplay=1';

    // Show the video iframe
    video.classList.remove('hidden');
    video.style.opacity = '1'; // Ensure it's visible

    // Start playing the video
    if (video.contentWindow && video.contentWindow.postMessage) {
      video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  });
});


//# sourceMappingURL=main.js.map
